import { Route, Router, Routes } from 'react-router-dom'
import './App.css'
import Home from './Components/Home/Home'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import About from './Components/About/About'
import Faq from './Components/Faq/Faq'
import Download from './Components/Download/Download'
import Contact from './Components/Contact/Contact'
import CommingSoon from './Components/Extra/CommingSoon/CommingSoon'
import PrivacyPolicy from './Components/Privacy/PrivacyPolicy';
import PrivacyPolicyNew from './Components/Privacy/PrivacyPolicyNew';


const App = () => {
  return (
    <div className="app">
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/faq' element={<Faq/>}/>
        <Route path='/download' element={<Download/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/termsAndCondition' element={<PrivacyPolicy/>}/>
        <Route path='/privacyPolicy' element={<PrivacyPolicyNew/>}/>
      </Routes>
      <ToastContainer/>
    </div>
  )
}

export default App